import React from 'react';
import { Box, Typography } from '@mui/material';

const UserDefaultPage = () => {
  return (
    <Box 
      sx={{
        textAlign: 'center',
        mt: 4, // Add some top margin for spacing
      }}
    >
      <Typography variant="h4" component="h2" fontWeight="bold">
        Welcome to the Dashboard
      </Typography>
      <Typography 
        variant="body1" 
        sx={{
          mt: 2, 
          color: 'text.secondary',
        }}
      >
        Select an option from the menu to get started.
      </Typography>
    </Box>
  );
};

export default UserDefaultPage;
